import script from "./SecurityConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./SecurityConfiguration.vue?vue&type=style&index=0&id=222327e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-222327e7"]])

export default __exports__